"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfMeasurementsService = void 0;
const VcfMeasurementsError_1 = require("../errors/VcfMeasurementsError");
class VcfMeasurementsService {
    constructor(vcfMeasurementsClient) {
        this.vcfMeasurementsClient = vcfMeasurementsClient;
    }
    async getMeasurementsRange(vin) {
        var _a, _b, _c, _d, _e;
        const ranges = [
            'cngRange_km',
            'dieselRange_km',
            'electricRange_km',
            'gasRange_km',
            'gasolineRange_km',
            'lpgRange_km',
            'petrolRange_km',
        ];
        const measurementsStatusResponse = await this.vcfMeasurementsClient.getMeasurementsStatus(vin, 
        // fuelLevel needs a comma appended. VCF have issues parsing the parameter otherwise
        'range,fuelLevel,');
        try {
            const data = (_b = (_a = measurementsStatusResponse.data) === null || _a === void 0 ? void 0 : _a.find((array) => array.id === 'range')) !== null && _b !== void 0 ? _b : (_c = measurementsStatusResponse.data) === null || _c === void 0 ? void 0 : _c.find((array) => array.id === 'fuelLevel');
            if (!data)
                throw new VcfMeasurementsError_1.VcfMeasurementsError('Could not get "data" object from the API');
            const lastUpdate = data.carCapturedTimestamp;
            const primaryEngineType = (_e = (_d = data.properties.find((p) => p.name === 'primaryEngineType')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '';
            let value = 0;
            if (data.id === 'range') {
                ranges.forEach((range) => {
                    var _a, _b;
                    value += parseInt((_b = (_a = data.properties.find((p) => p.name === range)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '0');
                });
            }
            return { lastUpdate, value, primaryEngineType };
        }
        catch (e) {
            throw new VcfMeasurementsError_1.VcfMeasurementsError('Could not parse VCF measurements response');
        }
    }
    async getMeasurementsOdometerRange(vin) {
        const measurementsStatusResponse = await this.vcfMeasurementsClient.getMeasurementsStatus(vin, 'odometer,range');
        return measurementsStatusResponse;
    }
    async getAdBlueRange(vin) {
        var _a;
        const measurementsStatusResponse = await this.vcfMeasurementsClient.getMeasurementsStatus(vin, 'range');
        if (!measurementsStatusResponse.data) {
            throw new VcfMeasurementsError_1.VcfMeasurementsError('Could not get "data" object from the API');
        }
        const adBlueRangeString = (_a = measurementsStatusResponse.data[0].properties.find((entry) => entry.name === 'adBlueRange_km')) === null || _a === void 0 ? void 0 : _a.value;
        const adBlueRange = adBlueRangeString ? parseInt(adBlueRangeString) : undefined;
        return adBlueRange;
    }
}
exports.VcfMeasurementsService = VcfMeasurementsService;
//# sourceMappingURL=VcfMeasurementsService.js.map